import CalendarHeader from "../components/CalendarHeader";
import CalendarBody from "../components/CalendarBody";

import { useState } from "react";
import { appointmentsStatus } from "../../../types/calendar";
import { message } from "antd";
import dayjs from "dayjs";
import { isDateAndHourInThePast } from "../../../utils/DateUtils";
import { useIntl } from "react-intl";

export default function WeekView() {
  const intl = useIntl();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchFilter, setSearchFilter] = useState<string | null>(null);
  const [statusFilter, setStatusFilter] = useState<appointmentsStatus | null>(
    null
  );
  const [dateAndTime, setDateAndTime] = useState<{
    date: Date | null;
    startTime: string | null;
    finishTime: string | null;
  }>({
    date: null,
    startTime: null,
    finishTime: null,
  });
  const clickOnDay = ({
    date,
    startTime,
  }: {
    date: Date;
    startTime: string;
  }) => {
    if (isDateAndHourInThePast(date, startTime)) {
      message.error(
        intl.formatMessage({
          id: "pickFutureDate",
          defaultMessage: "يجب تحديد تاريخ مستقبلي",
        })
      );
      return;
    }

    setDateAndTime({
      date: date ? new Date(date) : dateAndTime.date,
      startTime: startTime ? startTime : dateAndTime.startTime,
      finishTime: dateAndTime?.finishTime,
    });
    if (date) {
      setIsModalOpen(true);
    }
  };

  return (
    <div className="flex h-full flex-col ">
      <CalendarHeader
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        dateAndTime={dateAndTime}
        setDateAndTime={setDateAndTime}
        setSearchFilter={setSearchFilter}
        setStatusFilter={setStatusFilter}
      />
      <CalendarBody
        dateAndTime={dateAndTime}
        setDateAndTime={setDateAndTime}
        clickOnDay={clickOnDay}
        searchFilter={searchFilter}
        statusFilter={statusFilter}
      />
    </div>
  );
}
